import * as _routes from './routes';
import automation from './automations';
import { formatMs } from '@mss/mss-component-library';

export const routes = { ..._routes };

export default {
  routes,
  automation,
  assetRefetchInterval: formatMs({ seconds: 10 }),
};
